export default function historyModule() {
  const section = jQuery('.history');
  if (!section) return;
  let currentItem;
  const items = section.find('article');

  function setCurrent(i) {
    currentItem = i;
    items.each((i, elem) => {
      if (i !== currentItem) {
        jQuery(elem).addClass('hidden').removeClass('visible');
        setTimeout(() => jQuery(elem).removeClass('hidden'), 240);
      }
      else jQuery(elem).addClass('visible');
    });
  }
  setCurrent(0);

  section.find('button.previous').click(() => {
    let current = currentItem - 1;
    setCurrent((current < 0) ? items.length - 1 : current);
  });
  section.find('button.next').click(() => {
    let current = currentItem + 1;
    setCurrent((current >= items.length) ? 0 : current);
  });

}



// WEBPACK FOOTER //
// ./scripts/modules/history.js